import(/* webpackMode: "eager" */ "/opt/gzoo/repo/frontend/src/app/page.tsx");
